<template>
  <svg
    :width="width"
    :height="height"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 300 300"
  >
    <defs id="defs15">
      <pattern y="0" x="0" height="6" width="6" patternUnits="userSpaceOnUse" />
    </defs>
    <g id="g4189" transform="scale(0.75,0.75)">
      <rect
        width="400"
        height="400"
        style="fill: #ffffff; fill-opacity: 1"
        x="0"
        y="0"
      />
      <g transform="matrix(7.8701756,0,0,7.8701756,695.19553,-948.4235)">
        <path
          style="
            fill: #ff0000;
            fill-opacity: 1;
            fill-rule: nonzero;
            stroke: none;
          "
          d="M 149.9375 79.222656 C 149.9375 79.222656 86.718651 79.222715 70.851562 83.345703 C 62.355775 85.719505 55.360154 92.715203 52.986328 101.33594 C 48.863375 117.20304 48.863281 150.0625 48.863281 150.0625 C 48.863281 150.0625 48.863375 183.0467 52.986328 198.66406 C 55.360154 207.28468 62.230834 214.15544 70.851562 216.5293 C 86.843592 220.77718 149.9375 220.77734 149.9375 220.77734 C 149.9375 220.77734 213.28168 220.77729 229.14844 216.6543 C 237.76923 214.28049 244.63977 207.53464 246.88867 198.78906 C 251.1366 183.04674 251.13672 150.1875 251.13672 150.1875 C 251.13672 150.1875 251.26156 117.20304 246.88867 101.33594 C 244.63977 92.715203 237.76923 85.844606 229.14844 83.595703 C 213.28168 79.222856 149.9375 79.222656 149.9375 79.222656 z M 129.82227 119.70312 L 182.42188 150.0625 L 129.82227 180.29688 L 129.82227 119.70312 z "
          transform="matrix(0.16941596,0,0,0.16941596,-88.332912,120.50856)"
        />
      </g>
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'YouTubeLogoIcon',
  props: {
    height: VueTypes.string.def('32'),
    width: VueTypes.string.def('32'),
  },
};
</script>

<style lang="scss"></style>
